import React from 'react';
import dayjs from 'dayjs';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { formatNumberLength } from '../../helpers';

//Estilos
import './Guia.css';
import print from '../../assets/imgs/print.png';
import qr_code from '../../assets/imgs/qr-code.png';

//Componentes
import GuiaLogsContainer from '../../components/guiaLogs/GuiaLogsContainer';

function Guia({ functions, states }) {
    const { masters, user, grapesVariety } = useGlobalContext();
    const {
        formatNumber,
        handlePrint,
        setOpenModal,
        setWatchImg,
        setWatchGuiaLogs,
    } = functions;

    const {
        watchGuiaLogs,
        GuiaData: {
            cabecera,
            itemsBodega,
            itemsProductor,
            usuario,
            nombre,
            apellido,
        },
        EstadoCerrada,
        EstadoDestinatario,
        WatchImg,
        Coordinates,
    } = states;

    return (
        <div className="guia-container">
            <h4 className="guia-title">
                Guia {cabecera?.serie}-
                {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                {formatNumber(cabecera?.numero, 4)}
            </h4>
            {cabecera?.imagen && (
                <section className="guia-info-section-img">
                    <button
                        className="btn btn-primary"
                        onClick={() => setWatchImg(!WatchImg)}
                    >
                        {!WatchImg ? 'Ver Imagen' : 'Ocultar Imagen'}
                    </button>
                    {WatchImg && <img src={cabecera?.imagen} alt="Guia" />}
                </section>
            )}
            <section className="guia-info-section">
                <label className="guia-label">
                    <span>Habilitada: </span>
                    <p>{cabecera?.estado ? 'SI' : 'NO'}</p>
                </label>
                <label className="guia-label">
                    <span>Matrícula Vehículo: </span>
                    <p>{cabecera?.matricula_Vehiculo}</p>
                </label>
                {
                    cabecera?.guia_Papel ? (
                        <label className="guia-label">
                            <span>Guía papel: </span>
                            <p>{cabecera?.guia_Papel}</p>
                        </label> ) : null
                }
                <label className="guia-label">
                    <span>Viñedo: </span>
                    <p>{cabecera?.viniedo}</p>
                </label>
                <label className="guia-label">
                    <span>Titular Viñedo: </span>
                    <p>{cabecera?.titular_Viniedo}</p>
                </label>
                <label className="guia-label">
                    <span>Titular Destinatario: </span>
                    <p>{cabecera?.titular_Destinatario}</p>
                </label>
                <label className="guia-label">
                    <span>Tipo Documento: </span>
                    <p>
                        {
                            masters.DocumentTypes?.find(
                                (ht) => ht.id === cabecera?.doc_id_tipo
                            )?.nombre
                        }
                    </p>
                </label>
                <label className="guia-label">
                    <span>Número Documento: </span>
                    <p>{cabecera?.doc_id}</p>
                </label>
                <label className="guia-label">
                    <span>Ubicación Viñedo: </span>
                    <p>
                        Latitud: {formatNumberLength(Coordinates.lat)},
                        Longitud: {formatNumberLength(Coordinates.lon)}
                    </p>
                </label>
                <label className="guia-label">
                    <span>Ubicación Destinatario: </span>
                    <p>{cabecera?.ubicacion_Destinatario}</p>
                </label>
                <label className="guia-label">
                    <span>Depto. Viñedo: </span>
                    <p>{cabecera?.departamento_Viniedo}</p>
                </label>
                <label className="guia-label">
                    <span>Depto. Destinatario: </span>
                    <p>
                        {masters?.Departments?.find(
                            (d) => d.id === cabecera?.departamento_Destinatario
                        )?.nombre.replaceAll('_', ' ')}
                    </p>
                </label>
                <label className="guia-label">
                    <span>Destino: </span>
                    <p>
                        {masters?.Destinos?.find(
                            (d) => d.id === cabecera?.destino
                        )?.nombre.replaceAll('_', ' ')}
                    </p>
                </label>
                {nombre && (
                    <label className="guia-label">
                        <span>Responsable: </span>
                        <p>
                            {nombre} {apellido} ({usuario})
                        </p>
                    </label>
                )}
            </section>
            <h4 className="guia-title">Uva Enviada</h4>
            <section className="guia-info-section">
                <table>
                    <thead>
                        <tr>
                            <th>Variedad</th>
                            <th>Kilos Ingresados</th>
                            <th>Precio Kg</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemsProductor?.map((it, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        {
                                            grapesVariety?.find(
                                                (gv) =>
                                                    gv.codigo === it.variedad
                                            )?.variedad
                                        }
                                    </td>
                                    <td>{it.kilos} kg</td>
                                    <td>${it.precio_Kg}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </section>
            <footer className="guia-section-footer">
                <label className="guia-label">
                    <span>Total Kilos Enviados: </span>
                    <p>{cabecera?.total_Kilos} kg</p>
                </label>
                <label className="guia-label">
                    <span>Fecha de Envío: </span>
                    <p>{dayjs(cabecera?.fecha_Envio).format('DD-MM-YYYY')}</p>
                </label>
                <label className="guia-label">
                    <span>Firma del Viticultor: </span>
                    <p>{cabecera?.firma_Viticultor}</p>
                </label>
            </footer>
            {EstadoCerrada && (
                <>
                    <h4 className="guia-title">Uva Recibida</h4>
                    <section className="guia-info-section">
                        <label className="guia-label">
                            <span>Titular Destinatario: </span>
                            <p>{cabecera?.titular_Destinatario}</p>
                        </label>
                        <table>
                            <thead>
                                <tr>
                                    <th>Variedad</th>
                                    <th>Kilos</th>
                                    <th>Grado de Glucosa</th>
                                    <th>Precio Kg</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsBodega?.map((it, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>
                                                {
                                                    grapesVariety?.find(
                                                        (gv) =>
                                                            gv.codigo ===
                                                            it.variedad
                                                    )?.variedad
                                                }
                                            </td>
                                            <td>
                                                {cabecera?.estado
                                                    ? `${it.kilos} Kg`
                                                    : ''}
                                            </td>
                                            <td>
                                                {cabecera?.estado
                                                    ? it.grado_Gluc
                                                    : ''}
                                            </td>
                                            <td>
                                                {cabecera?.estado
                                                    ? `$${it.precio_Kg}`
                                                    : ''}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <footer className="guia-section-footer">
                            <label className="guia-label">
                                <span>Total Kilos Recibidos: </span>
                                <p>
                                    {cabecera?.estado
                                        ? `${cabecera?.total_Kilos_Recibidos} Kg`
                                        : ''}
                                </p>
                            </label>
                            <label className="guia-label">
                                <span>Fecha de Recepción: </span>
                                <p>
                                    {cabecera?.estado
                                        ? cabecera?.fecha_Recepcion
                                            ? dayjs(
                                                  cabecera?.fecha_Recepcion
                                              ).format('DD-MM-YYYY')
                                            : ''
                                        : ''}
                                </p>
                            </label>
                            <label className="guia-label">
                                <span>Firma del Destinatario: </span>
                                <p>
                                    {cabecera?.estado
                                        ? cabecera?.firma_Destinatario
                                        : ''}
                                </p>
                            </label>
                        </footer>
                    </section>
                </>
            )}
            <footer className="guia-footer">
                <button
                    className="btn btn-primary guia-btn-print"
                    onClick={handlePrint}
                >
                    <img
                        className="guia-img-print"
                        src={print}
                        alt="Impresíon"
                    />
                    <small>Impresión</small>
                </button>
                {EstadoDestinatario && (
                    <button
                        className="btn btn-primary guia-btn-print"
                        onClick={() => setOpenModal(true)}
                    >
                        <img
                            className="guia-img-print"
                            src={qr_code}
                            alt="Impresíon"
                        />
                        <small>Generar Código QR</small>
                    </button>
                )}
            </footer>

            {user?.tipo === 3 && (
                <section className="profile-fieldset_4">
                    <h4 className="profile-title">Historial de la guía</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchGuiaLogs(!watchGuiaLogs)}
                    >
                        {!watchGuiaLogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {watchGuiaLogs && <GuiaLogsContainer />}
                </section>
            )}
        </div>
    );
}

export default Guia;
